/*! @azure/msal-browser v4.9.1 2025-03-26 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.9.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
